import { parseISO } from "date-fns";

export function serializeDateAndTime(date: string, time: string): Date {
  return parseISO(`${date}T${time}`);
}
